import { ReloadOutlined, WifiOutlined } from '@ant-design/icons';
import { Badge, Button, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { wsService } from '../services/websocket';
import { WSConnectionStatus } from '../types/websocket';

const WSWebSocketStatus: React.FC = () => {
  const [status, setStatus] = useState<WSConnectionStatus>('disconnected');

  useEffect(() => {
    // Set initial status
    setStatus(wsService.getConnectionStatus());

    // Subscribe to status changes
    const unsubscribe = wsService.onStatusChange((newStatus) => {
      setStatus(newStatus);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  const getStatusColor = (status: WSConnectionStatus): string => {
    switch (status) {
      case 'connected':
        return 'success';
      case 'connecting':
        return 'processing';
      case 'disconnected':
        return 'default';
      case 'error':
        return 'error';
      default:
        return 'default';
    }
  };

  const getStatusText = (status: WSConnectionStatus): string => {
    switch (status) {
      case 'connected':
        return 'Connected';
      case 'connecting':
        return 'Connecting...';
      case 'disconnected':
        return 'Disconnected';
      case 'error':
        return 'Connection Error';
      default:
        return 'Unknown';
    }
  };

  const handleReconnect = () => {
    wsService.reconnect();
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', maxWidth: '200px', overflow: 'hidden' }}>
      <WifiOutlined />
      <Tooltip title={`WS: ${getStatusText(status)}`}>
        <Badge
          status={getStatusColor(status) as any}
          text={getStatusText(status)}
          style={{ whiteSpace: 'nowrap' }}
        />
      </Tooltip>
      {(status === 'disconnected' || status === 'error') && (
        <Button
          type="text"
          size="small"
          icon={<ReloadOutlined />}
          onClick={handleReconnect}
          title="Reconnect WebSocket"
        />
      )}
    </div>
  );
};

export default WSWebSocketStatus;
